import logo from '@/assets/img/logo.svg';
import type { MenuItem } from '@/types/app';
import { Nav } from './Nav';

interface HeaderProps {
  siteName: string;
  primary: MenuItem[];
  secondary: MenuItem[];
}

export function Header({ siteName, primary, secondary }: HeaderProps) {
  return (
    <header className="header">
      <div className="header__container">
        <a href="/" className="header__logo">
          <img src={logo} alt={siteName} width={147} height={34} />
        </a>
        <Nav primary={primary} secondary={secondary} />
      </div>
    </header>
  );
}
